import React from 'react';
import ReactDOM from 'react-dom';
import reactToWC from 'react-to-webcomponent';
import App from './App';

const ReactToWebComponents = (Component) => {
  const classToExtendTo = reactToWC(Component, React, ReactDOM);
  return ((classToExtendTo) => {
    return class extends classToExtendTo {
      disconnectedCallback() {
        ReactDOM.unmountComponentAtNode(this);
      }
    };
  })(classToExtendTo);
};

export const createWebComponents = () => {
  customElements.define('wc-permissions', ReactToWebComponents(App));
};
